export function myProofPersonAdd(imageBase64, imageSubBase64, callback) {
	return {
    type: 'MY_PROOF_PERSON_ADD',
		payload: {
			imageBase64: imageBase64,
			imageSubBase64: imageSubBase64,
		},
		callback: callback,
	}
}

export function myProofAddNext(proofType, imageBase64Arr, callback) {
	return {
    type: 'MY_PROOF_ADD_NEXT',
		payload: {
			proofType: proofType,
			imageBase64Arr: imageBase64Arr,
		},
		callback: callback,
	}
}

export function myProofAdd(proofType, imageBase64, callback) {
	return {
    type: 'MY_PROOF_ADD',
		payload: {
			proofType: proofType,
			imageBase64: imageBase64,
		},
		callback: callback,
	}
}

export function myProofDel(proofType) {
	return {
    type: 'MY_PROOF_DEL',
		payload: {
			proofType: proofType,
		},
	}
}

export function myProofWantEdit(personWant, incomeWant, photoWant, singleWant, creditWant, callback) {
	return {
    type: 'MY_PROOF_WANT_EDIT',
		payload: {
			personWant: personWant,
      incomeWant: incomeWant,
      photoWant: photoWant,
      singleWant: singleWant,
      creditWant: creditWant,
		},
		callback: callback,
	}
}

export function myProofRekognitionCheck(imageBase64, callback) {
	return {
    type: 'MY_PROOF_REKOGNITION_CHECK',
		payload: {
			imageBase64: imageBase64,
		},
    callback: callback,
	}
}
